import React, { useState, useEffect, useMemo } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI, saveData, deleteData } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};
const Suppliers = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ name: "", status: "" });
  const [sortField, setSortField] = useState("created_at"); // Track the current sorted field
  const [sortOrder, setSortOrder] = useState("desc"); // Track the current sort order
  const [materialsOptions, setMaterialsOptions] = useState([]);
  const [error, setError] = useState(null);
  const isSubscribed = subscriptionStatus();
  useEffect(() => {
    fetchData();
    console.log("referching data", currentPage, filters, sortField, sortOrder);
  }, [filters, sortField, sortOrder]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters = {}) => {
    try {
      console.log("fetchData", filters, sortField, sortOrder);
      const token = localStorage.getItem("token");
      console.log("filters", filters);

      // Prepare query parameters

      // Dynamically construct query parameters, excluding empty sortField and sortOrder
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters,
        includeDeleted: "false",
      };

      // Add sortField and sortOrder only if they are not empty
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      console.log("Filter Params:", new URLSearchParams(filterParamsObj));

      // Create the query string
      const filterParams = new URLSearchParams(filterParamsObj).toString();
      console.log("Filter Params:", filterParams);
      // Fetch suppliers and materials concurrently
      const { data: suppliers, pagination } = await fetchDataFromAPI(
        `/api/suppliers`,
        filterParams,
        token
      );

      const { data: materials } = await fetchDataFromAPI(
        `/api/materials`,
        {},
        token
      );

      // Update state
      setSuppliers(suppliers || []);
      setMaterialsOptions(materials || []);
      setTotalPages(pagination?.totalPages || 1);

      console.log("Suppliers:", suppliers);
      console.log("Materials:", materials);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError(err.message);
    }
  };

  const handleAddRow = async () => {
    try {
      const newRow = {
        name: "New Supplier",
        contactNumber: "",
        email: "",
        location: "",
        socialLink: "",
        materials: "",
        status: "Active",
      };

      await saveData("/api/suppliers", newRow, "POST");
      fetchData();
    } catch (err) {
      console.error("Error adding row:", err);
    }
  };

  const handleEdit = async (id, updatedData) => {
    try {
      await saveData(`/api/suppliers/${id}`, updatedData);
      fetchData();
    } catch (err) {
      console.error("Error editing supplier:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/suppliers/${id}`);
      fetchData();
    } catch (err) {
      console.error("Error deleting supplier:", err);
    }
  };
  const handlePageChange = (newPage) => {
    console.log("Parent - Page changed to:", newPage); // Log in parent
    setCurrentPage(newPage); // Update the current page
    fetchData(newPage, 10); // Fetch new data
  };
  const handleSort = (field, order) => {
    console.log("handleSort,field,order", field, order);
    setSortField(field); // Update the sorted field
    setSortOrder(order); // Update the sort order (asc/desc)
  };
  const handleFilterChange = (newFilters) => {
    console.log("handleFilterChange", newFilters);
    setFilters(newFilters); // Update filters in the parent state
    fetchData(currentPage, newFilters); // Refetch data with new filters
  };

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Contact Number", accessor: "contact_number" },
    { header: "Email", accessor: "email" },
    { header: "Location", accessor: "location" },
    { header: "Social Link", accessor: "social_link" },
    {
      header: "Materials",
      accessor: "materials",
      type: "list",
      options: materialsOptions,
    },
    ,
    {
      header: "Rating",
      accessor: "rating",
      type: "range",
    },
    {
      header: "Status",
      accessor: "status",
      type: "dropdown", // Specify the column type
      options: [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
      ],
    },
  ];
  console.log("columns", columns);
  return (
    <DataTable
      title="Suppliers"
      columns={columns}
      data={suppliers}
      currentPage={currentPage}
      setData={setSuppliers}
      totalPages={totalPages}
      onSort={handleSort}
      sortOrder={sortOrder}
      sortField={sortField}
      onPageChange={handlePageChange}
      filters={filters}
      onFilterChange={handleFilterChange}
      onAddRow={handleAddRow}
      actions={[
        {
          label: "Edit",
          onClick: (row) => {
            const updatedData = { ...row, name: "Updated Name" };
            handleEdit(row.id, updatedData);
          },
        },
        {
          label: "Delete",
          onClick: (row) => handleDelete(row.id),
        },
      ]}
      apiEndpoint="/api/suppliers"
      itemsPerPage={10}
      fetchData={fetchData}
      getRangeInputProps={getRangeInputProps}
      selectedItems={suppliers.materials}
    />
  );
};

export default Suppliers;
